import { useEffect, useMemo, useState } from "react";
import { formatLocalDateTime } from "../../../../utils/formatDate";
import { reduzirNome } from "../../../../utils/reduzirNome";
import DropDown from "../../../../componentes/dropdown/dropdown";
import InputForm from "../../../../componentes/input/input";


function TabelaSolicitacoes({ solicitacoes }) {
    const [fase, setFase] = useState("");
    const [numeroProcesso, setNumeroProcesso] = useState("");
    const [status, setStatus] = useState("");
    const [filial, setFilial] = useState("");
    const [solicitanteNome, setSolicitanteNome] = useState("");

    const [listaFases, setListaFase] = useState([]);
    const [listaStatus, setListaStatus] = useState([]);
    const [listaFiliais, setListaFiliais] = useState([]);

    useEffect(() => {
        setListaFase([...new Set(solicitacoes.map((s) => s.fase))]);
        setListaStatus([...new Set(solicitacoes.map((s) => s.status))]);
        setListaFiliais([...new Set(solicitacoes.map((s) => s.filial))]);
    }, []);

    const solicitacoesFiltradas = useMemo(() => {
        return solicitacoes.filter((item) => {

            return (
                (fase ? item.fase === fase : true) &&
                (status ? item.status === status : true) &&
                (filial ? item.filial === filial : true) &&
                (numeroProcesso ? item.numeroProcesso.toString().includes(numeroProcesso.toLowerCase()) : true) &&
                (solicitanteNome
                    ? item.solicitanteNome
                        .toLowerCase()
                        .includes(solicitanteNome.toLowerCase())
                    : true)
            );
        });
    }, [fase, status, filial, solicitanteNome, numeroProcesso, solicitacoes]);

    return (
        <div>
            <div className="flex flex-wrap items-end mb-3">
                <div className="col-12 col-md-4 px-1">
                    <DropDown
                        nullValue="Todas as Fases"
                        optional
                        value={fase}
                        onChange={(e) => setFase(e.target.value)}
                        options={listaFases}
                        label="Filtrar por Fase"
                    />
                </div>
                <div className="col-12 col-md-2 px-1">
                    <DropDown
                        nullValue="Todos os Status"
                        label="Filtrar por Status"
                        optional
                        value={status}
                        onChange={(e) => setStatus(e.target.value)}
                        options={listaStatus}
                    />
                </div>
                <div className="col-12 col-md-2 px-1">
                    <DropDown
                        nullValue="Todas as Filiais"
                        label="Filtrar por Filial"
                        optional
                        value={filial}
                        onChange={(e) => setFilial(e.target.value)}
                        options={listaFiliais}
                    />
                </div>
                <div className="col-12 col-md-2 px-1">
                    <InputForm
                        type="text"
                        label="Filtrar por Solicitante"
                        value={solicitanteNome}
                        onChange={(e) => setSolicitanteNome(e.target.value)}
                        className="px-3 py-2 border border-input rounded-lg focus:ring-2 focus:ring-primary/40 focus:border-primary transition-colors duration-150"
                    />
                </div>
                <div className="col-12 col-md-2 px-1">
                    <InputForm
                        type="text"
                        label="Filtrar por Processo"
                        value={numeroProcesso}
                        onChange={(e) => setNumeroProcesso(e.target.value)}
                        className="px-3 py-2 border border-input rounded-lg focus:ring-2 focus:ring-primary/40 focus:border-primary transition-colors duration-150"
                    />
                </div>
            </div>
            <div className="overflow-y-auto max-h-[400px] border border-border rounded-lg">
                <table className="min-w-full divide-y divide-border">
                    <thead className="bg-table-header text-table-header-fg sticky topx-1">
                        <tr>
                            <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider">Processo</th>
                            <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider">Início</th>
                            <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider">Encerramento</th>
                            <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider">Fase</th>
                            <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider">Status</th>
                            <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider">Filial</th>
                            <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider">Solicitante</th>
                            <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider">Email</th>
                            <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider">Tipo Produto</th>
                            <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider">Departamento</th>
                            <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider">Prioridade</th>
                            <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider">Analista Cotação</th>
                            <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider">Valor Cotação</th>
                            <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider">Valor NF</th>
                            <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider">Diferença</th>
                            <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider">Gestor Imediato</th>
                            <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider">Gestor Corporativo</th>
                            <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider">Comprador</th>
                            <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider">Recebimento</th>
                            <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider">Vencimento</th>
                            <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider">Motivo</th>
                        </tr>
                    </thead>
                    <tbody className="bg-card divide-y divide-border">
                        {solicitacoesFiltradas.map((item, index) => (
                            <tr key={item.numeroProcesso} className="hover:bg-table-row-hover transition-colors">
                                <td className="px-4 py-3 whitespace-nowrap text-sm font-medium text-foreground">
                                    <a href={`http://fluig.yorkdistribuidora.com.br:35792/portal/p/1/pageworkflowview?app_ecm_workflowview_detailsProcessInstanceID=${item.numeroProcesso}`} target="_blank">
                                        {item.numeroProcesso}
                                    </a>
                                </td>
                                <td className="px-4 py-3 whitespace-nowrap text-sm text-foreground">{formatLocalDateTime(item.dataInicio?.toLocaleString())}</td>
                                <td className="px-4 py-3 whitespace-nowrap text-sm text-foreground">{formatLocalDateTime(item.dataEncerramento?.toLocaleString())}</td>
                                <td className="px-4 py-3 whitespace-nowrap text-sm text-muted-foreground">{item.status}</td>
                                <td className="px-4 py-3 whitespace-nowrap text-sm text-muted-foreground">{item.fase}</td>
                                <td className="px-4 py-3 whitespace-nowrap text-sm text-muted-foreground">{item.filial}</td>
                                <td className="px-4 py-3 whitespace-nowrap text-sm text-muted-foreground">{reduzirNome(item.solicitanteNome)}</td>
                                <td className="px-4 py-3 whitespace-nowrap text-sm text-muted-foreground">{item.solicitanteEmail}</td>
                                <td className="px-4 py-3 whitespace-nowrap text-sm text-muted-foreground">{item.tipoProduto}</td>
                                <td className="px-4 py-3 whitespace-nowrap text-sm text-muted-foreground">{item.departamento}</td>
                                <td className="px-4 py-3 whitespace-nowrap text-sm text-muted-foreground">{item.prioridade}</td>
                                <td className="px-4 py-3 whitespace-nowrap text-sm text-muted-foreground">{item.analistaCotacao}</td>
                                <td className="px-4 py-3 whitespace-nowrap text-sm text-muted-foreground">R$ {item.valorCotacao?.toFixed(2)}</td>
                                <td className="px-4 py-3 whitespace-nowrap text-sm text-muted-foreground">R$ {item.valorNf?.toFixed(2)}</td>
                                <td className={`px-4 py-3 whitespace-nowrap text-sm font-medium ${item.diferencaValor > 0 ? 'text-destructive' : 'text-success'}`}>{item.diferencaValor?.toFixed(2)}%</td>
                                <td className="px-4 py-3 whitespace-nowrap text-sm text-muted-foreground">{item.gestorImediato}</td>
                                <td className="px-4 py-3 whitespace-nowrap text-sm text-muted-foreground">{item.gestorCorporativo}</td>
                                <td className="px-4 py-3 whitespace-nowrap text-sm text-muted-foreground">{item.comprador}</td>
                                <td className="px-4 py-3 whitespace-nowrap text-sm text-muted-foreground">{item.dataRecebimento}</td>
                                <td className="px-4 py-3 whitespace-nowrap text-sm text-muted-foreground">{item.vencimento}</td>
                                <td className="px-4 py-3 whitespace-nowrap text-sm text-muted-foreground">{item.motivoSolicitacao}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div>
                <label className="d-flex py-2 text-muted-foreground">Registros: {solicitacoes.length}</label>
            </div>

        </div>
    );
}

export default TabelaSolicitacoes;
